export const PREFIX = {
    SIGN_TO_DOC: "Sign to Doc:",
};
